angular.module('admin.directives')

.directive('avmCompare', ['Dictionary', function(Dictionary){
  return {
    restrict: 'A',
    controllerAs: 'avmCtrl',
    bindToController: {
      home: '='
    },
    scope: {},
    templateUrl: '/admin/templates/partials/admins-avm-compare.html',

    controller: function(){
      var dictionary = new Dictionary();
      var ctrl = this;

      ctrl.lookup = function(prop,args,home){
        return dictionary[prop](ctrl.home,args);
      };

      ctrl.avmDate = function(source){
        if(!ctrl.home || !ctrl.home.avm) return 0;

        var avms = Helpers.sortByDate(_.filter(ctrl.home.avm, function(avm){
          if(avm.source && avm.source === source && avm.rental !== true){
            return true;
          }else
            return false;
        }),'updated');

        return avms.length ? avms[0].updated : moment.invalid();
      };

      ctrl.getAVMCompareData = function(){
        var cl = ctrl.lookup('avmCoreLogic');
        var rt = ctrl.lookup('avmRealtyTrac');
        var z = ctrl.lookup('avmZillow');

        return {
          labels: ['Z', 'CL', 'RT'],
          series: [ z, cl, rt ]
        }
      };

      ctrl.avmCompareData = ctrl.getAVMCompareData();

      ctrl.getBarOptions = function(){
        return {
          axisX:{
            offset: 0,
            showGrid: false,
            showLabel: false,
          },
          axisY:{
            showGrid: false,
            showLabel: true,
          },
          distributeSeries: true,
          horizontalBars: true,
          seriesBarDistance: 0,
        }
      };
    }
  }
}]);
